import { useMemo } from "react";
import {
  relevantGroupBys,
  relevantFilters,
  relevantAggregations,
  defaultDisplayColumns,
  selectableEntities,
} from "@vzbl/integrations";
import { SearchState } from "src/search/types";
import { fieldToTitle } from "src/utils/strings";
import { useIntegrationConfig } from "./lib/useIntegrationConfig";

const withLabel = (f: {
  target: string;
  attribute: string;
  canonical?: boolean;
}) => ({
  ...f,
  label: fieldToTitle(f),
});

const fromState = (searchState: SearchState, integrationConfig: any) => ({
  groupBys: relevantGroupBys(searchState, integrationConfig).map((f) =>
    withLabel(f)
  ),
  filters: relevantFilters(searchState, integrationConfig).map((f) =>
    withLabel(f)
  ),
  aggregations: relevantAggregations(searchState, integrationConfig),
  defaultDisplayColumns: defaultDisplayColumns(searchState, integrationConfig),
  selectableEntities: selectableEntities(integrationConfig),
});

export type EntitySelectors = ReturnType<typeof fromState>;

// return fields suitable for the explore page.
export function useEntitySelectors({
  state,
}: {
  state: SearchState;
}): EntitySelectors {
  const integrationConfig = useIntegrationConfig();
  return useMemo(
    () => fromState(state, integrationConfig.data),
    [integrationConfig, state]
  );
}
